import { api } from "./api";

export const GetFeeReport = async (addURL = '') => {
    let url = `/reports/financial?${addURL}`
    return await api.get(url)
}
export const GetFeeCollectionReport = async (addURL = '') => {
    let url = `/reports/collaction/report?${addURL}`
    return await api.get(url)
}
export const GetExpenseReport = async (addURL = '') => {
    let url = `/reports/expenses/report?${addURL}`
    return await api.get(url)
}
export const GetDueFeeReport = async (addURL = '') => {
    let url = `/reports/due/fees/report?${addURL}`
    return await api.get(url)
}

export const GetHostelReport = async (addURL = '') => {
    let url = `/reports/hostal?${addURL}`;
    return await api.get(url)
}

export const GetExpenceData = async (addURL = '') => {
    let url = `/reports/expenses?${addURL}`;
    return await api.get(url)
}

export const getTransitionDetails = async (addUrl = '') => {
    let url = `/reports/credit/debit?${addUrl}`;
    return await api.get(url)
}

//Staff report data

export const StaffReportList = async (addUrl = '') =>{
    let url = `reports/staff-report?${addUrl}`;
    return await api.get(url)
}


export const ExpenseChartData = async (addUrl = '') =>{
    return await api.get(`/expense/transactions/report?${addUrl}`)
}